<main class="mediumContainer">
    <div [class.reviewRole]="!isSuperuser" class="dashContainer">
        @if (!isMobile) {
            <div class="profile">
                <div class="sticky">
                    @if (community?.show_profile_tile_on_feed !== false) {
                        <app-user-info [largeAvatar]="true" [user]="currentUser"></app-user-info>
                    }
                    @if (!isMobile) {
                        <div class="gap-10 flex-col pinnedPosts">
                            @for (post of sidebarPosts; track trackByPostId($index, post)) {
                                <app-post-card
                                        (action)="loadPostFromSidebar(currentCommunityId)"
                                        [hidePoll]="true"
                                        [post]="post"
                                        [reducedContent]="true"
                                        [showPinnedBadge]="false"
                                ></app-post-card>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        @if (showStartAPostButton) {
            <div class="createPost">
                <button (click)="newPost()" [style.background-color]="community?.start_discussion_button_bg_color_hex"
                        [style.border-left]="community?.start_discussion_left_border_color_hex? '2px solid ' + community?.start_discussion_left_border_color_hex : 'unset'"
                        [style.color]="themeService.getReadableColor(community?.start_discussion_button_bg_color_hex)"
                        class="w-100 discussionBtn" mat-flat-button>
                    @if (community?.start_discussion_button_text) {
                        {{ community?.start_discussion_button_text }}
                    }
                    @if (!community?.start_discussion_button_text) {
                        Start Discussion
                    }
                </button>
            </div>
        }
        <app-dashboard-feed [currentCommunityId]="currentCommunityId" [isMobile]="isMobile"
                            [sidebarPosts]="sidebarPosts"/>
        @if (!isMobile) {
            <div class="sidebar">
                <div class="sticky rightSide">
                    @if (community) {
                        <app-recent-activity [community]="community"/>
                    }
                    @if (community?.show_points) {
                        <app-points-leaderboard class="halfSideBar"/>
                    }
                </div>
            </div>
        }
    </div>
</main>

